module.exports = __webpack_public_path__ + "2d87fa7d7d2618916e325fcd4757864b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/policy/pic13.png
// module id = 1857
// module chunks = 0